import { environment } from './../../../environments/environment';

// NOTE: Dictionay of All Calls
export const calls = {
    page: 'page',
    settings: 'app-settings',
    storage: 'storage',
};

export function getCall(call, id = null, params = {}) {
    let url = environment.urlBack + calls[call] + '/';
    if (id != '' && id != null && id != undefined) {
        url += id + '/';
    }
    if (params) {
        url += '?';
        for (const key in params) {
            url += key + '=' + params[key] + '&';
        }
        url = url.slice(0, -1);
    }
    return url;
}

export function addTokenToUrl(url: string, token: string): string {
    return token ? `${url}${token}/` : url;
}
